import * as z from "zod";

export const validateReclaimReferralCode = {
  name: "validateReclaimReferralCode" as const,
  input: z.object({ code: z.string().min(1).max(64) }),
  output: z.object({
    status: z.enum(["available", "unavailable"]),
    referrerName: z.string().optional(),
    profileImageUrl: z.string().url().nullable().optional(),
    referralCode: z.string().optional(),
  }),
};
